// HVAC ve Enerji Cozumleri modulunun ortak buton temasi.
//
// Amac: ayni anlami tasiyan her buton her ekranda ayni renkte ve ayni boyda olsun.
// Renkler Arcelik temasindan geliyor (src/modules/theme/palette.js):
//   primary   #FF9800  Arcelik turuncusu
//   secondary #424242  koyu gri
//
// NOT: palette.js'te hem primary hem secondary icin `contrastText` turuncu olarak
// tanimli. Bu yuzden MUI'nin `color="primary"` / `color="secondary"` prop'lari
// turuncu zemin uzerine turuncu yazi uretiyor. Dogru cozum palette'i duzeltmek ama
// bu tum uygulamayi (70+ ekran) etkiler; o yuzden burada renkler `!important` ile
// yerel olarak sabitleniyor.

export const HAVC_COLORS = {
  brand: '#FF9800',
  brandHover: '#F57C00',
  neutral: '#424242',
  neutralHover: '#616161',
  danger: '#d32f2f',
  dangerHover: '#b71c1c',
  line: '#e2e8f0',
  lineHover: '#cbd5e1',
  muted: '#64748b',
  mutedHover: '#f1f5f9',
  disabledBg: 'rgba(15, 23, 42, 0.12)',
  disabledFg: 'rgba(15, 23, 42, 0.38)'
};

// Tum butonlarin ortak olcusu. Boyut farki burada bitiyor.
const HAVC_BUTTON_BASE = {
  height: 40,
  minWidth: 120,
  paddingLeft: '20px',
  paddingRight: '20px',
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.875rem',
  lineHeight: 1,
  boxShadow: 'none',
  whiteSpace: 'nowrap',
  '& .MuiButton-startIcon svg, & .MuiButton-endIcon svg': { fontSize: '1.125rem' }
};

const contained = (bg, bgHover, shadow) => ({
  ...HAVC_BUTTON_BASE,
  backgroundColor: `${bg} !important`,
  color: '#ffffff !important',
  border: 'none !important',
  '&:hover': {
    backgroundColor: `${bgHover} !important`,
    boxShadow: shadow
  },
  '&.Mui-disabled': {
    backgroundColor: `${HAVC_COLORS.disabledBg} !important`,
    color: `${HAVC_COLORS.disabledFg} !important`,
    boxShadow: 'none'
  }
});

/** Ana eylem: Kaydet / Evet / Gonder / Devam Et — Arcelik turuncusu */
export const havcPrimaryButton = contained(
  HAVC_COLORS.brand,
  HAVC_COLORS.brandHover,
  '0 6px 16px -6px rgba(255, 152, 0, 0.8)'
);

/** Notr eylem: Sorgula / Kapat — koyu gri */
export const havcNeutralButton = contained(
  HAVC_COLORS.neutral,
  HAVC_COLORS.neutralHover,
  '0 6px 16px -6px rgba(15, 23, 42, 0.5)'
);

/** Yikici onay: Evet, Sil — kirmizi */
export const havcDangerButton = contained(
  HAVC_COLORS.danger,
  HAVC_COLORS.dangerHover,
  '0 6px 16px -6px rgba(211, 47, 47, 0.7)'
);

/** Vazgecme: Hayir / Vazgec — cerceveli notr */
export const havcCancelButton = {
  ...HAVC_BUTTON_BASE,
  backgroundColor: 'transparent !important',
  color: `${HAVC_COLORS.muted} !important`,
  border: `1px solid ${HAVC_COLORS.line} !important`,
  '&:hover': {
    backgroundColor: `${HAVC_COLORS.mutedHover} !important`,
    border: `1px solid ${HAVC_COLORS.lineHover} !important`
  },
  '&.Mui-disabled': {
    color: `${HAVC_COLORS.disabledFg} !important`,
    border: `1px solid ${HAVC_COLORS.line} !important`
  }
};
